import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUsageAudioResponse } from './get-usage-audio-response';
import { getUsageAudioResponseSchema } from './get-usage-audio-response';

export async function getUsageAudioApi(
  slug: string,
): Promise<IValidatedResponse<IGetUsageAudioResponse>> {
  return getRequest<IGetUsageAudioResponse>({
    path: `/challenges/${slug}/audio/usage`,
    schema: getUsageAudioResponseSchema,
  });
}
